import Component from 'component';
import _debounce from 'lodash/debounce';
import _template from 'lodash/template';
import _remove from 'lodash/remove';
import _isEmpty from 'lodash/isEmpty';
import predictiveTmpl from 'templates/predictive-search-item-insights';
import { SEARCH_GROUPS } from '../../constants';
import { Expo, TweenLite } from 'gsap';

class PredictiveSearch extends Component {
  constructor(el, config) {
    super(el, config)
  }

  setupDefaults() {
    this.dom = {
      $container: this.$el,
      $serchBox: this.$el.find('.wh-search-box'),
      $input: this.$el.find('.wh-search-box__field'),
      $searchBtn: this.$el.find('.wh-search-box__button'),
      $results: this.$el.find('.wh-predictive-search')
    };

    this.cssClasses = {
      searchGroup: 'wh-predictive-search-group'
    }

    this.currentRequest = [];
  }

  addListeners() {
    this.dom.$input.on('keyup input', _debounce(e => {
      this.onInputUp(e);
    }, 100));

    this.dom.$searchBtn.on('click touch', :: this.onSearch);
    this.$el.on('click touch', '.wh-predictive-search-group__items .keyword', :: this.onKeywordClick);
    this.$el.on('click touch', '.wh-predictive-search-group__title', :: this.onHeadingClick);
  }

  getResults(keyword, contenttype, requestIndex) {
    let queryParms = { keyword, contenttype }
    if (window.location.search.indexOf('person=') !== -1 && window.location.search.indexOf('personname=') !== -1 && contenttype === 'insight') {
      queryParms = { keyword: keyword, contenttype: contenttype, isforperson: 1 }
    }
    this.dom.$serchBox.addClass('loading');

    return $.ajax({
      url: this.config.predictiveEndpoint,
      data: queryParms,
      beforeSend: () => {
        if (this.currentRequest[requestIndex] && this.currentRequest[requestIndex] !== null) {
          this.currentRequest[requestIndex].abort();
        }
      }
    });
  }

  async renderResults(value) {
    const data = await Promise.all([
      this.currentRequest[0] = this.getResults(value, 'news', 2)
    ]);

    _remove(data, n => _isEmpty(n));

    this.dom.$serchBox.removeClass('loading');

    this.$el.trigger('search:keyword', data);

    let items = '';

    if (data.length > 0) {
      data.forEach(item => {
        items += _template(predictiveTmpl)(item);
      });

      this.dom.$results.html(items);
    } else {
      const noResults = this.dom.$results.data('no-results-txt');
      const noResultsString = '<li class="wh-predictive-search__none">' + noResults + '</li>';

      this.dom.$results.find('li').remove();
      this.dom.$results.html(noResultsString);
    }

    this.dom.$results.removeClass('loading');

    if (!this.dom.$results.hasClass('expanded')) {
      this.dom.$results.addClass('expanded');
      TweenLite.set(this.dom.$results, { height: 'auto', ease: Expo.easeOut });
      TweenLite.from(this.dom.$results, 0.4, { height: 0, ease: Expo.easeInOut });
    }
  }

  destroyResults() {
    TweenLite.to(this.dom.$results, 0.5, {
      height: 0, ease: Expo.easeOut, onComplete: () => {
        this.dom.$results.removeClass('expanded');
        this.dom.$results.find('li').remove();
      }
    });
  }

  onInputUp(e) {
    const value = this.dom.$input.val().trim();

    if (value.length < 2) {
      this.destroyResults();

      return;
    }

    if (e.which === 13) {
      this.searchOnNewsListingPage(value);
      return;
    }

    this.renderResults(value)
      .catch(err => {
        if (err.statusText !== 'abort') {
          console.error('There was an error getting your results', err);
        }
      });
  }

  searchOnNewsListingPage(value) {
    window.open(
      `${this.dom.$serchBox.data('search-url')}${value ? `?keyword=${value}`:''}`,
      '_self'
    );
  }

  onKeywordClick(e) {
    const $target = $(e.currentTarget);
    const searchGroup = $target.parents(`.${this.cssClasses.searchGroup}`).data('predictive-search-group');
    const keyword = $target.html();
    const value = $target.data('value');

    this.$el.trigger('search:filter', { filterGroup: 'insights', value, keyword });

    this.destroyResults();
  }

  onHeadingClick(e) {
    const $target = $(e.currentTarget);
    if ($target.hasClass('wh-predictive-search-group__title--false')) {
      return;
    }

    this.searchOnNewsListingPage();
  }

  onSearch(e) {
    e.preventDefault();

    const value = this.dom.$input.val().trim();
    this.searchOnNewsListingPage(value);
  }
}

export default PredictiveSearch;



// WEBPACK FOOTER //
// ./src/js/components/newsroom/PredictiveSearch.js